import { DataBean } from "../DataBean";


export class AccountRole extends DataBean {

    public async addAccountToRole(idAccount: number, idEmployee: number, idRole: number): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.securitymanager.AccountRole_addAccountToRole_Number_Number_Number", [idAccount, idEmployee, idRole]);
    }

    public async activateUserAccountLocal(idAccount: number, user: string, password: string ): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.bean.account.AbstractAccount_activateUserAccountLocal_Number_String_String", [idAccount, user, password]);
    }

    public async desactivateUserAccount(accountID: number ): Promise<any> {
        return this.getCustomService("OrangeBase", "Number_desactivateUserAccount_Number", [accountID]);
    }

}